import { render, staticRenderFns } from "./LicenceManagement.vue?vue&type=template&id=16d21e3c&"
import script from "./LicenceManagement.vue?vue&type=script&lang=js&"
export * from "./LicenceManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports